/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import {
  Modal, Label, Dropdown, Checkbox, Radio, Popup, Icon
} from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import Dropzone from 'react-dropzone';
import Update from 'immutability-helper';
import cx from 'classnames';
import Loader from '../Loader/Loader';
import api from '../../api';
import closeBtn from '../../images/components/new_scan/close-btn.svg';
import profileIcon from '../../images/common/profile_icon_big.png';
import AssigningProjectModal from './AssigningProjectModal';

class NewUserModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMCU: props.isOpenMCU,
      isOpenMAP: false,
      //rowData: '',
      authData: 'user',
      userName: '',
      userNameError: '',
      email: '',
      emailError: '',
      company: '',
      companyList: [],
      companyError: '',
      checkValue: [],
      selectedProjectList: [],
      globalError: '',
      itemsChecked: false,
      modalAlertMsg: '',
      modalAlertTitle: '',
      modalAlert: false,
      isLoader: false,
      authorizedIps: 'all',
      file: {
        error: false,
        value: '',
        errorMsg: '',
        preview: null,
        image: null,
      },
      selectedIps: '',
      ipsError: '',
    };
    //this.picChanged = false;
    this.handleAuthChange = this.handleAuthChange.bind(this);
    this.handleUserNameChange = this.handleUserNameChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleCompanyChange = this.handleCompanyChange.bind(this);
    this.handleRemoveProject = this.handleRemoveProject.bind(this);
    this.handleAddProject = this.handleAddProject.bind(this);
    this.handleMAPClose = this.handleMAPClose.bind(this);
    this.handleProjectList = this.handleProjectList.bind(this);
    this.handleProjectCheckAll = this.handleProjectCheckAll.bind(this);
    this.handleProjectCheckChange = this.handleProjectCheckChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleRadioChange = this.handleRadioChange.bind(this);
    this.handleCloseAlert = this.handleCloseAlert.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.closeNewUserModal = this.closeNewUserModal.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    const { isOpenMCU } = this.props;

    if (isOpenMCU !== prevProps.isOpenMCU) {
      this.setState({
        isOpenMCU,
        selectedProjectList: [],
        userName: '',
        userNameError: '',
        email: '',
        emailError: '',
        company: '',
        companyError: '',
        globalError: '',
        checkValue: [],
        itemsChecked: false,
        file: {
          error: false,
          value: '',
          errorMsg: '',
          preview: null,
          image: null,
        },
        selectedIps: '',
        ipsError: '',
        authData: 'user',
        authorizedIps: 'all',
      }, () => {
        if (isOpenMCU && this.props.state.user.isSuperAdmin) {
          this.getCompanyList();
        }
      });
    }
  }

  handleAuthChange(e) {
    this.setState({
      authData: e.currentTarget.dataset.id,
    });
  }

  handleUserNameChange(e) {
    const { translate } = this.props;
    if (this.getByteLength(e.target.value) > 30) {
      this.setState({
        userNameError: translate('modal.message.user_name_rule'),
      });
      return false;
    }
    this.setState({
      userName: e.target.value,
      userNameError: '',
    });
  }

  handleEmailChange(e) {
    const { translate } = this.props;
    if (this.getByteLength(e.target.value) > 254) {
      this.setState({
        emailError: translate('modal.message.email_limited_char')
      });
      return false;
    }
    this.setState({
      email: e.target.value,
      emailError: '',
    });
  }

  handleCompanyChange(e, data) {
    this.setState({
      company: data.value,
      companyError: '',
    });
  }

  handleRemoveProject() {
    const { checkValue, selectedProjectList } = this.state;
    if (checkValue.length === 0) {
      return false;
    }
    const newState = selectedProjectList.filter((item) => {
      return checkValue.indexOf(item.id) === -1;
    });
    this.setState({
      selectedProjectList: newState,
      checkValue: [],
      itemsChecked: false,
    });
  }

  handleAddProject() {
    this.setState({
      isOpenMAP: true,
    });
  }

  handleProjectList(newArr) {
    const { selectedProjectList } = this.state;

    this.setState({
      selectedProjectList: Update(selectedProjectList, {
        $push: newArr,
      }),
    });
  }

  handleProjectCheckAll() {
    const { itemsChecked, selectedProjectList } = this.state;
    const newState = [];

    if (itemsChecked) {
      this.setState({
        itemsChecked: false,
        checkValue: [],
      });
    } else {
      const num = selectedProjectList.length;
      let i = 0;
      for (i; i < num; i++) {
        newState.push(selectedProjectList[i].id);
      }

      const unique = newState.reduce((a, b) => {
        if (a.indexOf(b) < 0) {
          a.push(b);
        }
        return a;
      }, []);
      this.setState({
        itemsChecked: true,
        checkValue: unique,
      });
    }
  }

  handleProjectCheckChange(e, { value }) {
    const { checkValue } = this.state;
    let newState;
    if (checkValue.indexOf(value) > -1) {
      newState = checkValue.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...checkValue, value];
    }
    this.setState({
      checkValue: newState,
    });
  }

  handleMAPClose() {
    this.setState({
      isOpenMAP: false,
    });
  }

  handleCloseAlert() {
    this.setState({ modalAlert: false });
    this.props.completeCallback(200);
    this.closeNewUserModal();
  }

  handleSave() {
    const formData = new FormData();
    const projectId = [];
    const { authData, selectedIps, authorizedIps } = this.state;
    const { translate } = this.props;

    formData.append('email', this.state.email);
    formData.append('name', this.state.userName);

    if (this.state.file.image) {
      formData.append('image', this.state.file.image);
    }

    if (this.state.selectedProjectList.length !== 0) {
      this.state.selectedProjectList.map((item) => {
        return projectId.push(item.id);
      });
    }

    if (this.props.state.user.isSuperAdmin) {
      formData.append('selected_company_id', this.state.company);
    } else if (this.props.state.user.isAdminOnly) {
      formData.append('selected_role', this.state.authData);
      let i = 0;
      for (i; i < projectId.length; i++) {
        formData.append('project_ids[]', projectId[i]);
      }
    }

    if (this.props.state.user.isAdmin && authData === 'admin') {
      if (authorizedIps === 'all') {
        formData.append('authorized_ips', []);
      }
      if (authorizedIps === 'specific') {
        const newArray = this.separateString(selectedIps);
        let j = 0;
        for (j; j < newArray.length; j++) {
          formData.append('authorized_ips[]', newArray[j]);
        }
      }
    }

    if (!this.validateFields()) {
      return null;
    }

    this.setState({
      modalAlert: true,
      isLoader: true,
    });

    api
      .postCompanyUser(formData)
      .then((response) => {
        const res = response.response;
        if (!res.is_use_link) {
          this.setState({
            //resetPage: false,
            isLoader: false,
            modalAlertMsg: translate('modal.message.user_register_success'),
            modalAlertTitle: translate('modal.title.notice'),
          });
        } else {
          this.setState({
            //resetPage: false,
            isLoader: false,
            modalAlertMsg: res.link,
            modalAlertTitle: translate('modal.title.attention'),
          });
        }
      })
      .catch((err) => {
        console.log(err);
        const o = err.data.response;

        if (o.error === '422-365') {
          this.setState({
            isLoader: false,
            modalAlert: false,
            globalError: translate('modal.error.error_422_365'),
          });
        } else if (o.error === '422-368') {
          this.setState({
            isLoader: false,
            modalAlert: false,
            globalError: translate('modal.error.user_server_first'),
          });
        } else if (o.error === '422-367') {
          this.setState({
            isLoader: false,
            modalAlert: false,
            globalError: translate('modal.error.user_smtp_first'),
          });
        } else {
          this.setState({
            isLoader: false,
            modalAlert: false,
            globalError: o.error_description || translate('modal.error.unknow_error'),
          });
        }
      });
  }

  handleRadioChange(e, { value }) {
    this.setState({
      authorizedIps: value,
    });
  }

  handleInputChange(e) {
    this.setState({
      selectedIps: e.target.value,
      ipsError: '',
    });
  }

  onDrop(files) {
    //this.picChanged = true;
    this.setState({
      file: {
        preview: URL.createObjectURL(files[0]),
        image: files[0],
      },
    });
  }

  getCompanyList() {
    const obj = {
      pageNum: 1,
      limitCnt: '',
      search: '',
    };
    api
      .getCompanyList(obj)
      .then((response) => {
        const data = response.response;
        const newData = data.map((item, index) => {
          return {
            key: index,
            text: item.name,
            value: item.company_id,
          };
        });

        this.setState({
          companyList: newData,
        });
      })
      .catch((err) => {
        console.log(err);
        //this.setState({
        //isLoading: false,
        //});
      });
  }

  getByteLength(text) {
    let l = 0;
    for (let i = 0; i < text.length; i++) l += text.charCodeAt(i) > 128 ? 2 : 1;
    return l;
  }

  validateFields() {
    const {
      userName, email, company, authorizedIps, selectedIps, authData
    } = this.state;
    const { translate } = this.props;

    // eslint-disable-next-line no-useless-escape
    const re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    const validation = {
      userName: true,
      email: true,
      company: true,
      authorizedIps: true,
    };

    if (userName.trim().length === 0) {
      this.setState({
        userNameError: translate('modal.error.user_name_required'),
      });
      this.userNM.scrollIntoView();
      this.userNM.focus();
      validation.userName = false;
      return false;
    }
    if (email.trim().length === 0) {
      this.setState({
        emailError: translate('modal.error.required_email'),
      });
      this.email.scrollIntoView();
      this.email.focus();
      validation.email = false;
      return false;
    }

    if (!re.test(email)) {
      this.setState({
        emailError: translate('modal.error.invalid_email'),
      });
      this.email.scrollIntoView();
      this.email.focus();
      validation.email = false;
    }

    if (this.props.state.user.isSuperAdmin) {
      if (company.trim().length === 0) {
        this.setState({
          companyError: translate('modal.error.required_company'),
        });
        validation.company = false;
        return false;
      }
    }

    if (this.props.state.user.isAdmin && authData === 'admin' && authorizedIps === 'specific') {
      if (selectedIps.trim().length === 0) {
        this.setState({
          ipsError: translate('profile.error.one_ip_address'),
        });
        validation.authorizedIps = false;
        return false;
      }
      const ipsArray = this.separateString(selectedIps);
      const regexIpv = /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/;
      let i = 0;
      for (i; i < ipsArray.length; i++) {
        if (!regexIpv.test(ipsArray[i])) {
          this.setState({
            ipsError: translate('profile.error.invalid_ip_address'),
          });
          validation.authorizedIps = false;
          return false;
        }
      }
    }
    return validation.userName && validation.email;
  }

  separateString(value) {
    const separatedArray = [];
    const originalString = value.replace(/ /g, '');
    let previousIndex = 0;
    let i = 0;
    for (i; i < originalString.length; i++) {
      if (originalString[i] === ',') {
        const separated = originalString.slice(previousIndex, i);
        separatedArray.push(separated);
        previousIndex = i + 1;
      }
    }
    separatedArray.push(originalString.slice(previousIndex, i));
    return separatedArray;
  }

  closeNewUserModal() {
    this.setState({
      isOpenMCU: false,
    });
    this.props.closeModal();
  }

  render() {
    const {
      authData,
      userName,
      email,
      companyList,
      company,
      selectedProjectList,
      checkValue,
      itemsChecked,
      authorizedIps,
    } = this.state;
    const { translate } = this.props;

    //let baseUrl = '//'.concat(location.hostname);
    let profileImgUrl = '';
    /*
    if (process.env.NODE_ENV === 'development') {
      baseUrl = baseUrl.concat(':3000');
    } else {
      baseUrl = location.port !== '' ? baseUrl.concat(':', location.port) : '';
    }
*/
    const globalErrorClass = this.state.globalError !== '' ? 'show' : '';
    const userNameErrorClass = this.state.uesrNameError !== '' ? 'show' : '';
    const emailErrorClass = this.state.emailError !== '' ? 'show' : '';
    const companyErrorClass = this.state.companyError !== '' ? 'show' : '';
    const ipsErrorClass = this.state.ipsError !== '' ? 'show' : '';

    profileImgUrl = this.state.file.preview
      //baseUrl.concat(this.props.state.user.image_thumb, '?', new Date().getTime()) ||
      || profileIcon;
    if (this.props.state.user.scanConfig.isLoading) {
      return <Loader />;
    }

    return (
      <Modal open={this.state.isOpenMCU} onClose={this.closeNewUserModal}>
        <div className="setting_popup_wrap">
          <div className="setting_popup default_popup">
            <div className="setting_popup_header">
              <h2 className="popup_name">{translate('modal.title.new_local_user')}</h2>
              <div
                className={`error ${globalErrorClass}`}
                style={{
                  fontSize: '15px',
                  fontWeight: '700',
                  color: '#ef4136',
                }}
              >
                {this.state.globalError}
              </div>
              <a className="popup_close_button" style={{ cursor: 'pointer' }} onClick={this.closeNewUserModal}>
                <img
                  src={closeBtn}
                  alt=""
                />
              </a>
            </div>
            <Scrollbars>
              <div className="setting_popup_inner_header">
                {/*this.props.state.user.use_ldap ? (
                  <Dropzone
                    className="avata"
                    multiple={false}
                    accept="image/*"
                    style={{ pointerEvents: 'none' }}
                  >
                    <img className="profileImg" src={profileImgUrl} role="presentation" />
                  </Dropzone>
                ) : (
                */}
                <Dropzone
                  onDrop={this.onDrop}
                >
                  {({ getRootProps, getInputProps }) => {
                    return (
                      <div {...getRootProps({ className: 'user_avata' })}>
                        <input {...getInputProps()} />
                        <img
                          className="profileImg"
                          src={profileImgUrl}
                          role="presentation"
                          style={{ cursor: 'pointer' }}
                          alt=""
                        />
                      </div>
                    );
                  }}
                </Dropzone>
                {/*})}*/}
              </div>
              <div className="setting_popup_contnets">
                <div className="setting_popup_content_wrap" />
                <div className="setting_popup_content_wrap">
                  <table className="table ">
                    <colgroup>
                      <col style={{ width: '15%' }} />
                      <col style={{ width: '15%' }} />
                      <col style={{ width: '25%' }} />
                      <col style={{ width: '25%' }} />
                      <col style={{ width: '20%' }} />
                    </colgroup>
                    <tbody>
                      <tr>
                        <td>
                          <h3 className="content_title">{translate('modal.title.type')}</h3>
                          <div className="setting_popup_content">
                            <div className="text_box">
                              <Label color="green" horizontal>
                                {translate('modal.title.local')}
                              </Label>
                            </div>
                          </div>
                        </td>
                        {this.props.state.user.isAdminOnly && (
                          <td>
                            <h3 className="content_title">{translate('settings.list.permission')}</h3>
                            <div className="setting_popup_content">
                              <div className="switch">
                                <a
                                  className={cx({
                                    checked: authData === 'user',
                                  })}
                                  data-id="user"
                                  onClick={this.handleAuthChange}
                                  style={{ cursor: 'pointer' }}
                                >
                                  {translate('settings.list.user')}
                                </a>
                                <a
                                  className={cx({
                                    checked: authData === 'admin',
                                  })}
                                  data-id="admin"
                                  onClick={this.handleAuthChange}
                                  style={{ cursor: 'pointer' }}
                                >
                                  {translate('settings.list.admin')}
                                </a>
                              </div>
                            </div>
                          </td>
                        )}
                        {this.props.state.user.isSuperAdmin && (
                          <td>
                            <h3 className="content_title">
                              {translate('list.title.company')}
                              <em style={{ marginLeft: '0' }} className="asterisk" />
                            </h3>
                            <div className="setting_popup_content">
                              <Dropdown
                                options={companyList}
                                defaultValue={company}
                                placeholder={translate('modal.message.select_a_company')}
                                onChange={this.handleCompanyChange}
                                disabled={companyList.length === 0}
                              />
                              <div
                                className={`error ${companyErrorClass}`}
                                style={{
                                  marginTop: '6px',
                                  marginLeft: '5px',
                                  fontSize: '12px',
                                  fontWeight: '700',
                                  color: '#ef4136',
                                }}
                              >
                                {this.state.companyError}
                              </div>
                            </div>
                          </td>
                        )}
                        {
                          ((this.props.state.user.isAdminOnly && authData === 'admin') || this.props.state.user.isSuperAdmin)
                          && (
                            <td>
                              <h3 className="content_title">{translate('profile.title.authorize_user_ip')}</h3>
                              <div className="setting_popup_content">
                                <div className="inline_radio">
                                  <Radio
                                    label={translate('profile.title.all_ip')}
                                    value="all"
                                    checked={authorizedIps === 'all'}
                                    onChange={this.handleRadioChange}
                                  />
                                  <Radio
                                    label={translate('profile.title.specific_ip')}
                                    value="specific"
                                    checked={authorizedIps === 'specific'}
                                    onChange={this.handleRadioChange}
                                  />
                                </div>
                              </div>
                            </td>
                          )
                        }
                        {
                          ((this.props.state.user.isAdminOnly && authData === 'admin') || this.props.state.user.isSuperAdmin) && authorizedIps === 'specific'
                          && (
                            <td>
                              <div className="setting_popup_content" style={{ position: 'relative' }}>
                                <Popup
                                  trigger={<Icon name="question circle outline" />}
                                  content={translate('profile.message.multiple_ip_addr')}
                                  position="top left"
                                  size="small"
                                  className="question"
                                />
                                <input
                                  type="text"
                                  value={this.state.selectedIps}
                                  placeholder={translate('profile.title.authorized_ip_addr')}
                                  onChange={this.handleInputChange}
                                />
                                <div
                                  className={`error ${ipsErrorClass}`}
                                  style={{
                                    marginTop: '6px',
                                    marginLeft: '5px',
                                    fontSize: '12px',
                                    fontWeight: '700',
                                    color: '#ef4136',
                                  }}
                                >
                                  {this.state.ipsError}
                                </div>
                              </div>
                            </td>
                          )
                        }
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="setting_popup_content_wrap">
                  <table className="table ">
                    <colgroup>
                      <col style={{ width: '50%' }} />
                      <col style={{ width: '50%' }} />
                    </colgroup>
                    <tbody>
                      <tr>
                        <td>
                          <h3 className="content_title">
                            {translate('settings.list.user_name')}
                            <em style={{ marginLeft: '0' }} className="asterisk" />
                          </h3>
                          <div className="setting_popup_content">
                            <input
                              type="text"
                              value={userName}
                              placeholder="User Name"
                              onChange={this.handleUserNameChange}
                              ref={(ref) => {
                                this.userNM = ref;
                              }}
                            />
                            <div
                              className={`error ${userNameErrorClass}`}
                              style={{
                                marginTop: '6px',
                                marginLeft: '5px',
                                fontSize: '12px',
                                fontWeight: '700',
                                color: '#ef4136',
                                postion: 'absolute',
                              }}
                            >
                              {this.state.userNameError}
                            </div>
                          </div>
                        </td>
                        <td>
                          <h3 className="content_title">
                            {translate('settings.list.email')}
                            <em style={{ marginLeft: '0' }} className="asterisk" />
                          </h3>
                          <div className="setting_popup_content">
                            <input
                              type="text"
                              value={email}
                              onChange={this.handleEmailChange}
                              placeholder="Email"
                              ref={(ref) => {
                                this.email = ref;
                              }}
                            />
                            <div
                              className={`error ${emailErrorClass}`}
                              style={{
                                marginTop: '6px',
                                marginLeft: '5px',
                                fontSize: '12px',
                                fontWeight: '700',
                                color: '#ef4136',
                                postion: 'absolute',
                              }}
                            >
                              {this.state.emailError}
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                {this.props.state.user.isAdminOnly && (
                  <div className="setting_popup_content_wrap">
                    <h3 className="content_title">
                      {translate('settings.list.assigned_project')}
                      <div className="button_box">
                        <a
                          className="delete_button"
                          onClick={this.handleRemoveProject}
                          style={{ cursor: 'pointer' }}
                        >
                          {translate('modal.button.delete')}
                        </a>
                        <a
                          className="add_button"
                          onClick={this.handleAddProject}
                          style={{ cursor: 'pointer' }}
                        >
                          {translate('modal.button.add')}
                        </a>
                      </div>
                    </h3>
                    <div className="setting_popup_content">
                      <div
                        className="table_wrap table_type_3"
                        style={{
                          padding: '0 10px',
                          border: '1px solid #e5e5e5',
                          borderRadius: '5px',
                        }}
                      >
                        <table className="table table_type_3">
                          <colgroup>
                            <col style={{ width: '36px' }} />
                            <col style={{ width: '' }} />
                            <col style={{ width: '20%' }} />
                            <col style={{ width: '20%' }} />
                          </colgroup>
                          <tbody>
                            <tr>
                              <th>
                                <Checkbox
                                  checked={itemsChecked}
                                  onChange={this.handleProjectCheckAll}
                                />
                              </th>
                              <th>{translate('settings.list.group_name')}</th>
                              <th>{translate('settings.list.group_member')}</th>
                              <th className="tar">{translate('modal.title.assigned')}</th>
                            </tr>
                            {selectedProjectList.length === 0 ? (
                              <tr>
                                <td colSpan="4">{translate('modal.message.need_add_project')}</td>
                              </tr>
                            ) : (
                              selectedProjectList.map((list) => {
                                return (
                                  <tr key={list.id}>
                                    <td>
                                      <Checkbox
                                        value={list.id}
                                        checked={checkValue.indexOf(list.id) > -1}
                                        onChange={this.handleProjectCheckChange}
                                      />
                                    </td>
                                    <td>{list.name}</td>
                                    <td>{list.member_count}</td>
                                    <td className="tar">-</td>
                                  </tr>
                                );
                              })
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </Scrollbars>
            <div className="setting_popup_button_wrap">
              <a
                className="button cencel_button"
                onClick={this.closeNewUserModal}
                style={{ cursor: 'pointer' }}
              >
                {translate('modal.button.cancel')}
              </a>
              <a
                className="button save_button"
                onClick={this.handleSave}
                style={{ cursor: 'pointer' }}
              >
                {translate('modal.button.save')}
              </a>
            </div>
          </div>
        </div>
        <AssigningProjectModal
          isOpenMAP={this.state.isOpenMAP}
          isOpenMCU={this.state.isOpenMCU}
          closeModal={this.handleMAPClose}
          projects={selectedProjectList}
          completeCallback={this.handleProjectList}
          translate={translate}
        />
        <Modal open={this.state.modalAlert} onClose={this.handleCloseAlert}>
          {this.state.isLoader ? (
            <Loader />
          ) : (
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div className="modal_popup confirm">
                  <h2 className="title">{this.state.modalAlertTitle}</h2>
                  <p className="text">{this.state.modalAlertMsg}</p>
                  <div className="button_wrap">
                    <a onClick={this.handleCloseAlert} className="center_button">
                      {translate('modal.button.ok')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal>
      </Modal>
    );
  }
}

export default inject('state')(observer(NewUserModal));
